import styled from "@emotion/styled"
import { keyframes } from "@emotion/core"

const varEntry = keyframes`
   to {
     opacity: 1;
     transform: translateY(0);
   }
 `

export const Table = styled(`table`)`
  animation: ${varEntry} 0.5s ease forwards;
  margin: ${p => p.theme.space[5]} 0 0 0;
  opacity: 0;
  transform: translateY(${p => p.theme.space[4]});
  width: 100%;
`

export const TableBody = styled(`tbody`)``

export const TableRow = styled(`tr`)`
  &:last-of-type {
    td {
      border: 0;
    }
  }
`

export const TableHeader = styled(`th`)`
  color: ${p => p.theme.colors.grey[70]};
  font-size: ${p => p.theme.fontSizes[0]};
  font-weight: normal;
  padding: ${p => p.theme.space[3]} 0 ${p => p.theme.space[3]}
    ${p => p.theme.space[3]} !important;
`
